import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MessageService, ConfirmationService } from 'primeng/api';
import { Component, OnInit, Input, EventEmitter, Output, Inject } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { AlertService } from '@app/_services';
import * as moment from 'moment';
import { PrimeNGConfig } from 'primeng/api';
import { LostFoundService } from '../lost-found.service';
import { LostFound } from '../lost-found';
import { ReservationService } from '@app/_components/reservation/reservation.service';
import { PropertyService } from '@app/_components/property';

@Component({
    selector: 'app-lost-found',
    templateUrl: './lost-found.component.html',
    styleUrls: ['./lost-found.component.css'],
    providers: [MessageService, ConfirmationService],
    standalone: false
})
export class LostFoundComponent implements OnInit {
    reservations: any;
    reservationId: any;
    properties: any;
	title = "Reservation";
    reservation: any;

	constructor(
		private propertyService: PropertyService,
		private reservationService: ReservationService,
		private primengConfig: PrimeNGConfig,
		private lostFoundService: LostFoundService,
		private alertService: AlertService,
		private messageService: MessageService,
		private confirmationService: ConfirmationService,
		private formBuilder: UntypedFormBuilder,
		@Inject(MAT_DIALOG_DATA) data: any) {
		this.formTitle = data.title,
			this.lostFound = data.lostFound,
			this.reservationId = data.reservationId,
			this.statuses = lostFoundService.statuses;
	}

	@Input() lostFound: LostFound;
	@Output() doAdd = new EventEmitter<any>();
	@Output() doUpdate = new EventEmitter<any>();
	@Output() doDelete = new EventEmitter<any>();

	// data
	lostFoundId: number;

	// forms
	form1: UntypedFormGroup;
	formLoading = false;
	formAlert: String;
	formTitle: String;
	isReservationId: boolean = false;

	statuses: any;

	validationMessages = {
		'lostFoundId': [],
		'shortTermRentalId': [{ type: 'required', message: 'Required' }],
		'propertyCode': [],
		'reservationId': [],
		'itemName': [],
		'itemDesc': [],
		'status': [],
		'guestInquired': [],
		'guestNotified': [],
		'itemReturned': [],
		'returnDate': [],
		'trackingNumber': [],
		'opsNotes': [],
	};

	ngOnInit() {
		
		this.fetchProperties();
		this.fetchReservations();
		this.primengConfig.ripple = true;
		this.formBuild();

		// if we were passed the whole lostFound object
		if (this.lostFound) {
			console.log("this.lostFound : "+this.lostFound);
			this.lostFoundId = this.lostFound.lostFoundId;
			this.reservationId = this.lostFound.reservationId;
			this.fixDates();
			this.form1.patchValue(this.lostFound);
		}else{
			this.form1.patchValue({
				status: "lost",
			});
		}
	}

	onFormDelete() {
		console.log('onRowDelete: ' + JSON.stringify(event));
		this.confirmationService.confirm({
			message: 'Are you sure you want to delete Id# ' + this.lostFoundId + '?',
			header: 'Confirm',
			icon: 'pi pi-exclamation-triangle',
			accept: () => {
				this.formDelete()
			},
			reject: () => {
				this.messageService.add({ severity: 'info', summary: 'Canceled', detail: 'Delete canceled.', life: 3000 });
			}
		});
	}

	formAdd() {
		try {
			this.form1.value.reservationId = this.reservationId;
			if (this.form1.value.reservationId == null) {
				this.isReservationId = true;
				return;
			}
			// stop here if form is invalid
			this.form1.markAllAsTouched();
			if (this.form1.invalid) {
				return;
			}
			console.log('property-add post: ' + JSON.stringify(this.form1.value));
			this.formLoading = true;
			
			this.lostFoundService.add(this.form1.value)
				.subscribe(
					(res: any) => {
						console.log('property-add SUCCESS: ' + JSON.stringify(res));
						this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message });
						this.lostFound = res.data.lostFound;
						this.doAdd.emit(this.lostFound);
					},
					(err: any) => {
						console.log('lostFound-add FAIL: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { this.formLoading = false; });

		} catch (error) {
			this.alertService.error(error);
		}
	}

	formUpdate() {
		console.log('lostFound: ' + JSON.stringify(this.form1.value));
		try {
			// stop here if form is invalid
			this.form1.markAllAsTouched();
			if (this.form1.invalid) {
				return;
			}
			this.formLoading = true;

			this.lostFoundService.update(this.form1.value)
				.subscribe(
					(res: any) => {
						console.log('property-update SUCCESS: ' + JSON.stringify(res));
						this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message });
						this.lostFound = res.data.lostFound;
						this.doUpdate.emit(this.lostFound);
					},
					(err: any) => {
						console.log('property-update FAIL: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { this.formLoading = false; });
		} catch (error) {
			console.log('Form Invalid: ' + JSON.stringify(error));
			this.alertService.error(error);
		}
	}

	formDelete() {
		try {
			this.formLoading = true;
			this.lostFoundService.delete(this.lostFound.lostFoundId)
				.subscribe(
					(res: any) => {
						console.log('lostFound-delete SUCCESS: ' + JSON.stringify(res));
						this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message });
						this.doDelete.emit(this.lostFound);
					},
					(err: any) => {
						console.log('lostFound-add FAIL: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { this.formLoading = false; });
		} catch (error) {
			this.alertService.error(error);
		}
	}

	formBuild() {
		this.form1 = this.formBuilder.group({
			lostFoundId: [this.lostFoundId],
			shortTermRentalId:  ['', Validators.required],
			propertyCode: [],
			reservationId: [],
			itemName: [],
			itemDesc: [],
			status: [],
			guestInquired: [],
			guestNotified: [],
			itemReturned: [],
			returnDate: [],
			trackingNumber: [],
			opsNotes: [],
			});
	}

	fixDates() {
		// create date objects - why can't primeng do this?
		this.lostFound.lostFoundDate = moment(this.lostFound.lostFoundDate).toDate();
	}
	
	fetchReservations() {
		if (!this.reservations || this.reservations === undefined || this.reservations.length < 1) {
			try {
				this.reservationService.findAll()
					.subscribe(
						res => {
							console.log('findAllReservations: ' + JSON.stringify(res));
							this.reservations = res.data.reservations;
							return this.reservations;
						},
						err => {
							console.log('Feature-Update FAIL: ' + JSON.stringify(err));
							this.alertService.error(err);
						},
						() => { });
			} catch (error) {
				console.log('Form Invalid: ' + JSON.stringify(error));
				this.alertService.error(error);
			}
		}
		else {
			// console.log('properties are ' + this.properties);
			return (this.reservations);
		}
	}
	
	reservationInfoItem(event : any){
		console.log("reservation reservation : "+ JSON.stringify(event));
		this.isReservationId = false;
		this.reservationId = event.reservationId;
		this.fetchReservationById(this.reservationId);
	}
	
	fetchReservationById(reservationId: any) {
			try {
				this.reservationService.findById(reservationId)
					.subscribe(
						res => {
							console.log('findById reservation : ' + JSON.stringify(res));
							this.reservation = res.data.reservation;
							this.form1.patchValue({
								/*firstName: this.reservation.guestProfile.firstName,
								lastName: this.reservation.guestProfile.lastName,
								emailAddress: this.reservation.guestProfile.emailAddress,
								adr1: this.reservation.guestProfile.adrStreet,
								adr2: this.reservation.guestProfile.adrStreet2,
								adrCity: this.reservation.guestProfile.adrCity,
								adrState: this.reservation.guestProfile.adrState,
								adrCountry: this.reservation.guestProfile.adrCountry,
								mobilePhone: this.reservation.primaryMobilePhone,
								checkInDate: moment(this.reservation.checkInDate).toDate(),
								checkOutDate: moment(this.reservation.checkOutDate).toDate(),*/
								shortTermRentalId: this.reservation.shortTermRental.shortTermRentalId,
								propertyCode: this.reservation.shortTermRental.propertyCode,
							});
							return this.reservation;
						},
						err => {
							console.log('Feature-Update FAIL: ' + JSON.stringify(err));
							this.alertService.error(err);
						},
						() => { });
			} catch (error) {
				console.log('Form Invalid: ' + JSON.stringify(error));
				this.alertService.error(error);
			}
		}
	
	fetchProperties() {
		if (!this.properties || this.properties === undefined || this.properties.length < 1) {
			try {
				this.propertyService.findAllSummary()
					.subscribe(
						res => {
							// console.log('findAllPropertiesSummary: ' + JSON.stringify(res));
							this.properties = res.data.properties;
							return this.properties;
						},
						err => {
							console.log('Feature-Update FAIL: ' + JSON.stringify(err));
							this.alertService.error(err);
						},
						() => { });
			} catch (error) {
				console.log('Form Invalid: ' + JSON.stringify(error));
				this.alertService.error(error);
			}
		}
		else {
			// console.log('properties are ' + this.properties);
			return (this.properties);
		}
	}
}
